import { transitionPath } from 'router5';
import { getRoute } from './get-route';
/**
 * Получение массива деактивированных расширенных роутов
 */
export var getDeactivatedRoutes = function (toState, fromState, routes) {
    var toDeactivate = transitionPath(toState, fromState).toDeactivate;
    return toDeactivate.map(function (segment) { return getRoute(segment, routes); });
};
